import cxs from 'cxs';
import { COLOURS, FONT_WEIGHTS } from '../../../common/styles/vars';

const SIZE_PARAMS = {
  square: {
    width: '205px',
    height: '205px',
    maxWrapperHeight: '255px'
  },
  small: {
    width: '300px',
    height: '70px',
    maxWrapperHeight: '80px'
  },
  medium: {
    width: '300px',
    height: '150px',
    maxWrapperHeight: '160px'
  }
};

export const WRAPPER = (size) => cxs({
  display: 'flex',
  flexDirection: 'row',
  overflow: 'hidden',
  flexWrap: 'wrap',
  maxHeight: SIZE_PARAMS[size].maxWrapperHeight
});

export const CREATE_WRAPPER = cxs({
  marginRight: '16px'
});

export const CREATE_BOX = (size) => cxs({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: SIZE_PARAMS[size].width,
  height: SIZE_PARAMS[size].height,
  cursor: 'pointer',
  background: `
    linear-gradient(to right, ${COLOURS.grey.athens.bigFat} 50%, transparent 0%) top/20px 2px repeat-x,
    linear-gradient(${COLOURS.grey.athens.bigFat} 50%, transparent 0%) right/2px 20px repeat-y,
    linear-gradient(to right, ${COLOURS.grey.athens.bigFat} 50%, transparent 0%) bottom/20px 2px repeat-x,
    linear-gradient(${COLOURS.grey.athens.bigFat} 50%, transparent 0%) left/2px 20px repeat-y
  `,
  ':hover': {
    background: `
      linear-gradient(to right, ${COLOURS.grey.athens.smallSkinny} 50%, transparent 0%) top/20px 2px repeat-x,
      linear-gradient(${COLOURS.grey.athens.smallSkinny} 50%, transparent 0%) right/2px 20px repeat-y,
      linear-gradient(to right, ${COLOURS.grey.athens.smallSkinny} 50%, transparent 0%) bottom/20px 2px repeat-x,
      linear-gradient(${COLOURS.grey.athens.smallSkinny} 50%, transparent 0%) left/2px 20px repeat-y
    `
  },
  '> .create-text': {
    marginLeft: '8px'
  }
});

export const CREATE_TEXT = cxs({
  color: COLOURS.grey.regent,
  fontWeight: FONT_WEIGHTS.regular,
  textTransform: 'uppercase',
  textAlign: 'center',
  marginTop: '15px',
  letterSpacing: '1px'
});

export const LOADING_WRAPPER = cxs({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginRight: '16px',
  padding: '24px',
  width: '157px',
  height: '157px',
  background: COLOURS.mono.white
});

export const LOADING_H1 = cxs({
  height: '15px',
  backgroundColor: COLOURS.grey.athens.bigFat,
  width: '153px',
  borderRadius: '6px',
  marginBottom: '16px'
});

export const LOADING_P = (width) => cxs({
  height: '15px',
  marginTop: '8px',
  backgroundColor: COLOURS.grey.athens.bigFat,
  width: `${width}px`,
  opacity: '0.75',
  borderRadius: '6px'
});